import { style } from 'typestyle'
import { important } from 'csx'
export const w100i = style({ width: important('100%') })
